import { useEffect, useRef, useState, memo, Dispatch } from 'react';
import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import useMediaQuery from '@mui/material/useMediaQuery';

import {
//   imgAlimentacion,
//   imgAudios,
//   imgEntrenamiento,
//   imgIconBono,
  imgAceleradores
} from '../../Shared/Images/producto2';

import { IProducto } from '../../Interfaces/IProductos';
import { IUserFromStorage } from '../../Interfaces/IUser';
// import { IAcelerador } from '../../Interfaces/IAceleradores';
import { AccionDetalle } from '../../Shared/data/FormReducer';
import { IMaterial, IResultado } from '../../Interfaces/IResultado';
import { inicioService, resultadoService } from '../../Services/Form';
import Loading from '../../Utils/Loading';
import ModalMaterialesCopy from './DialogMateriales';
import ScrollToBottomFab from '../FAB/ScrollToBottomFab';
import ResultadosPC from './ResultadosComponents/ResultadosPC';
import ModalEvaluacion from '../ModalEvaluacion/ModalEvaluacion';
import ExpiredMembreship from '../ExpiredMembreship/ExpiredMembreship';
import DialogProductDescription from '../Dialog/DialogProductDescription';
import useSecondsToTime from './ResultadosComponents/Hooks/useSecondsToTime';
import MaterialSection from './ResultadosComponents/Material/MaterialSection';

import logo from '../../Shared/Images/fit4challenge.png';
import { atrasIcon, iconAhorra, iconAudios, iconEntrenamiento, iconPlanAlimentacion, iconPreguntasFrecuentes, iconProgreso } from '../../Shared/Images';

import './styles/resultadosMobile.css';
import UploadVideoEvaluation from '../ModalEvaluacion/UploadVideoEvaluation/UploadVideoEvaluation';


interface IResultados {
  dispatch?: Dispatch<AccionDetalle>;
  loading_timeProp: number;
}


const Resultados = ({ dispatch, loading_timeProp } : IResultados) => {

  const loading_time = loading_timeProp * 1000;
  const [isLoading, setIsLoading] = useState(true);
  const [loadingPage, setLoadingPage] = useState(true);

  const [resultado, setResultado] = useState<IResultado>();
  // const [expanded, setExpanded] = React.useState<string | false>('panel0');
  const [arrMateriales, setArrMateriales] = useState<IMaterial[]>();

  // const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const matches = useMediaQuery('(max-width: 650px)');
  const [producto, setProduct] = useState<IProducto>();

  const { totalSeconds, time, setTotalSeconds } = useSecondsToTime(0);

  const [percentage, setPercentage] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);
  const [change, setChange] = useState<boolean>(false);
  const [semana, setSemana] = useState<number>(4);
  // materiales

  const [modalMaterialesAdvice, setModalMaterialesAdvice] = useState<boolean>(false);
  const [modalMaterialCopy, setModalMaterialCopy] = useState<string>('');


  let value = localStorage.getItem('user');
  let user : IUserFromStorage = typeof value === 'string' ? JSON.parse(value) : '';
  const timer = useRef(null);
  const [currentItemModal, setCurrentItemModal] = useState<'rutinas' | 'alimentacion'>();
  const [linkPdfAlimentacion, setLinkPdfAlimentacion] = useState('');

  const [isOpenModalEvaluacion, setIsOpenModalEvaluacion] = useState<boolean>(false);
  const [isOpenModalUploadVideo, setIsOpenModalUploadVideo] = useState<boolean>(false);

  // const [varianteAlimentacion, setVarianteAlimentacion] = useState<number>();

  // const matches1 = useMediaQuery('(max-width: 1025px)');
  // const matches2 = useMediaQuery('(max-width: 1250px)');

  const isOldDevice = () => {
    // Implementa una lógica simple para detectar dispositivos antiguos
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );
  };

  useEffect(() => {
    timer.current = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(timer.current);
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(timer.current);
  }, []);

  useEffect(() => {
    setTotalSeconds(seconds);
    // Actualiza el valor en el localStorage
    localStorage.setItem('seconds', String(seconds));
  }, [seconds]);

  useEffect(() => {
    if (seconds < 0) {
      if (modalMaterialesAdvice) {
        if (currentItemModal === 'rutinas') {
          setModalMaterialesAdvice(false);
          navigate('/misRutinas');
        } else {
          window.open(linkPdfAlimentacion, '_blank'); // abre la URL en una nueva pestaña
        }
      }
    }
  }, [seconds]);

  useEffect(() => {
    resultadoService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
    })
      .then((response) => {
        if (response.data.status === 200) {

          setResultado(response.data.data);
          setPercentage(75);
          setSeconds(response.data.data.duracionSegundos);

          if ([1, 4, 7, 10].includes(response.data.data.mes)) {
            setSemana(4);
          } else if ([2, 5, 8, 11].includes(response.data.data.mes)) {
            setSemana(8);
          } else if ([3, 6, 9, 12].includes(response.data.data.mes)) {
            setSemana(12);
          }
        } else {

          setResultado(null);

        }
      })
      .finally(() => {
        setLoadingPage(false);
      })
  }, [change]);

  useEffect(() => {
    if (resultado) {
      setArrMateriales([
        {
          title: 'Aceleradores',
          subtitle: '',
          src: 'aceleradores',
          pdf: false,
          pdfLink: '',
          copy: '',
          url: '/aceleradores',
          imgFromProject: imgAceleradores,
        },
        {
          title: 'Tus entrenamientos',
          subtitle: `semana 1 a ${semana}`,
          src: resultado.displayPdfEntrenamiento,
          pdf: true,
          pdfLink: resultado.linkPdfEntrenamiento,
          copy: resultado.copyEntrenamiento,
          url: '/misRutinas',
          imgFromProject: iconEntrenamiento,
        },
        {
          title: 'Plan de alimentación',
          subtitle: `de ${resultado.calorias} calorías`,
          src: resultado.displayPdfAlimentacion,
          pdf: true,
          pdfLink: '',
          copy: resultado.copyAlimentacion,
          url: '/planAlimentacion',
          imgFromProject: iconPlanAlimentacion,
        },
        {
          title: 'Preguntas frecuentes',
          subtitle: '',
          src: resultado.displayPdfEntrenamiento,
          pdf: true,
          pdfLink: resultado.linkPdfEntrenamiento,
          copy: resultado.copyEntrenamiento,
          url: '/preguntasFrecuentes',
          imgFromProject: iconPreguntasFrecuentes,
        },
        {
          title: 'Tu progreso',
          subtitle: ``,
          src: resultado.displayPdfAlimentacion,
          pdf: false,
          url: '/tuProgreso',
          imgFromProject: iconProgreso,
        },
        {
          title: 'Audios semanales',
          subtitle: ``,
          src: resultado.displayAudios,
          pdf: false,
          pdfLink: '',
          url: '/podcasts',
          imgFromProject: iconAudios,
        },
        {
          title: 'Ahorra 30% en tu dieta',
          subtitle: ``,
          src: resultado.displayPdfBono,
          pdf: true,
          pdfLink: resultado.linkPdfBono,
          imgFromProject: iconAhorra,
          pdfBono: true,
        }
      ]);
      
      if( resultado.mostrarControl ) {
        setIsOpenModalEvaluacion(true);
      } else if ( !resultado.mostrarControl && !resultado.subioVideo && resultado.mes >= 3 ) {
        setIsOpenModalUploadVideo(true);
      }
    }
  }, [resultado]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setIsLoading(false);
    }, loading_time);
    return () => clearTimeout(timerId);
  }, []);

  useEffect(() => {
    inicioService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
    })
      .then((res) => {
        localStorage.setItem('sexoUser', res.data.data.sexo.toString());
      })
      .catch(() => {
        toast.error("Ocurrió un error inesperado, por favor inténtelo de nuevo");
      })
  }, [])

  const navigate = useNavigate();

  return (
    <>
      {loadingPage ? (
        <div className="h-[100dvh] flex items-center justify-center">
          <Loading />
        </div>
      ) : (
        <>
          {resultado ? (
            <>
              <div className="w-full">
                {isLoading ? (
                  <div
                    className="flex align-items-center justify-content-center"
                    style={{ height: '70vh' }}
                  >
                    <div>
                      <Loading></Loading>
                      <Container maxWidth="xs">
                        ¡Genial! Estamos procesando tus respuestas para diseñar tu programa
                        personalizado. ¡Pronto tendrás en tus manos tu plan de entrenamiento y
                        comidas para comenzar tu transformación!
                      </Container>
                    </div>
                  </div>
                ) : (
                  <>
                    {!matches ? (
                      <ResultadosPC
                        dispatch={dispatch}
                        isRutinas={currentItemModal}
                        seconds={seconds}
                        resultado={resultado}
                        setCurrentItemModal={setCurrentItemModal}
                        setLinkPdfAlimentacion={setLinkPdfAlimentacion}
                        linkPdfAlimentacion={linkPdfAlimentacion}
                        currentItemModal={currentItemModal}
                      />
                    ) : (
                      <div className="fit4-page">

                        <div className="fit4-header">

                          {/* Logo */}
                          <div className="fit4-logo-container">
                            <img
                              src={logo}
                              alt='Fit4 Logo'
                            />
                          </div>

                          {/* Navigation Row */}
                          <div className="fit4-nav-row">
                            <div
                              className="fit4-back-btn"
                              onClick={() => navigate('/')}
                            >
                              <img
                                src={atrasIcon}
                                alt="Volver"
                              />
                            </div>
                            <h1 className="fit4-phase-title">
                              {(resultado.fase && resultado.mes) ? `${resultado.fase.toUpperCase()} — MES ${resultado.mes}` : '' }
                            </h1>
                          </div>

                          {/* Progress Section */}
                          <div className="fit4-progress-section">
                            <div className="fit4-progress-card">
                              <div className="fit4-progress-label">
                                <span>Tu avance</span>
                                <span className="fit4-progress-percentage">{resultado.porcentajeAvancePorMes}%</span>
                              </div>
                              <div className="fit4-progress-track">
                                <div
                                  className="fit4-progress-fill"
                                  style={{ '--progress-width': `${resultado.porcentajeAvancePorMes}%` } as React.CSSProperties}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Motivational Text */}
                          {resultado.mensajeMotivacion ? (
                            <div className="fit4-motivation" dangerouslySetInnerHTML={{__html: resultado.mensajeMotivacion}} />
                          ) : (
                            <div className="fit4-motivation">
                              <p>
                                <b>¡Empecemos con tu gran cambio!</b> <br/> Acabas de entrar en FIT4CHALLENGE y aquí no perdemos el tiempo. Los próximos 90 días van a transformar tu cuerpo y tu mentalidad por completo. Pero antes, hay un primer paso. Este video es la diferencia entre quedarte igual o finalmente lograrlo. <b>Míralo porque esto lo cambia TODO.</b>
                              </p>
                            </div>
                          )}

                          {/* Module Cards */}
                          <div className="fit4-modules">
                            {arrMateriales?.map((material: any, index: number) => (
                              <MaterialSection
                                key={index}
                                material={material}
                                seconds={seconds}
                                setModalMaterialCopy={setModalMaterialCopy}
                                setModalMaterialesAdvice={setModalMaterialesAdvice}
                                setCurrentItemModal={setCurrentItemModal}
                                setLinkPdfAlimentacion={setLinkPdfAlimentacion}
                              />
                            ))}
                          </div>

                          {/* Scroll FAB */}
                          {/* <ScrollToBottomFab
                            size='small'
                            iconSize={'normal'}
                            mobile
                          /> */}

                        </div>

                        {dialogOpen && (
                          <DialogProductDescription
                            isOpen={dialogOpen}
                            setIsOpen={setDialogOpen}
                            producto={producto!}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>


              {isOpenModalEvaluacion && (
                <ModalEvaluacion 
                  isOpen={isOpenModalEvaluacion}
                  setIsOpen={setIsOpenModalEvaluacion}
                />
              )}
              {isOpenModalUploadVideo && (
                <UploadVideoEvaluation 
                  isOpen={isOpenModalUploadVideo}
                  setIsOpen={setIsOpenModalUploadVideo}
                  dataRes={resultado}
                />
              )}

              {modalMaterialesAdvice && (
                <ModalMaterialesCopy
                  copy={modalMaterialCopy}
                  isOpen={modalMaterialesAdvice}
                  setIsOpen={setModalMaterialesAdvice}
                  timeInSeconds={seconds}
                  isRutinas={currentItemModal}
                />
              )}
            </>
          ) : (
            <ExpiredMembreship />
          )}
        </>
      )}
    </>
  );
};

export default memo(Resultados);
